import getAxiosInstance from "../../../common/mhiAxios";

export default {
    // テンプレート追加・更新
    updateTemplate(
        templateFile: File,
        templateId: number,
        templateName: string,
        templateType: string,
        userId: number
    ): Promise<any> {
        const params = new FormData();
        params.append("videoData", templateFile);
        params.append("id", String(templateId));
        params.append("name", templateName);
        params.append("type", templateType);
        params.append("userId", String(userId));

        return getAxiosInstance()
            .post("/api/uploadTemplate", params, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },

    // テンプレート削除
    deleteTemplate(templateId: number, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/deleteTemplate", { id: templateId, userId: userId })
            .then(({ data }) => data.templateList.id)
            .catch((error) => {
                return error.response;
            });
    },

    // テンプレート一覧取得
    getTemplates(typeList: string[]): Promise<any> {
        return getAxiosInstance()
            .post("/api/getTemplates", { typeList: typeList })
            .then(({ data }) => data.templateList)
            .catch((error) => {
                return error;
            });
    },

    // テンプレート名変更
    renameTemplate(id: number, name: string, userId: number): Promise<any> {
        return getAxiosInstance()
            .post("/api/renameTemplate", { id: id, newName: name, userId: userId })
            .then(({ data }) => data.templateList)
            .catch((error) => {
                return error;
            });
    },
};
